<div class="panel b">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="fs-4 d-flex align-items-center edit-btn">Marketing Details
      <p-toggleButton *ngIf="!isActionsDisabled"
        class="ml-3 lh-1"
        [disabled]="isActionsDisabled"
        [(ngModel)]="isEditMarketingDetails"
        (click)="onCancel()"
        offIcon="pi pi-pencil" onIcon="pi pi-times"
        onLabel="Cancel Edit" offLabel="Edit"
      ></p-toggleButton>
    </div>
    <div class="buttons-block" *ngIf="isEditMarketingDetails">
      <ng-container >
        <button id="md-savebtn" [disabled]="hasMaxLengthError"
                class="mb-sm btn btn-primary fa fa-save"
                type="button"
                (click)="onSave()"
        >Save</button>
      </ng-container>
    </div>
  </div>
  <div class="panel-body">
    <form [formGroup]="marketingDetails">
      <div class="row mb-3" *ngIf="!('externalProductName' | groupFieldCheck: groupAttributes)">
        <div class="col-lg-6">
          <div class="form-group"
               [ngClass]="{'warning' : showError('externalProductName')}">
            <label class="pt-1 pb-1">External Product Name</label><label style="color:red;">*</label>
            <input class="form-control"
                   pInputText
                   [readOnly]="!isEditMarketingDetails"
                   [attr.disabled]="isEditMarketingDetails ? null : true"
                   formControlName="externalProductName"/>
            <span class="warning-text" *ngIf="checkRequired('externalProductName')">This is a required field, fill in before submitting request</span>
            <span class="warning-text" *ngIf="checkMaxLength('externalProductName')">  {{showMaxLengthErrorMessage('externalProductName')}}  </span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="pt-1 pb-1">External Product Name - Short</label>
            <input class="form-control"
                   pInputText
                   [readOnly]="!isEditMarketingDetails"
                   [attr.disabled]="isEditMarketingDetails ? null : true"
                   formControlName="externalProductNameShort"/>
            <span class="warning-text" *ngIf="checkMaxLength('externalProductNameShort')">  {{showMaxLengthErrorMessage('externalProductName')}}  </span>
          </div>
        </div>
        <br/>
      </div>
      <div class="row mb-3" *ngIf="!('marketingDescription' | groupFieldCheck: groupAttributes)">
        <div class="col-lg-12">
          <div class="form-group" [ngClass]="{'warning' : checkRequired('marketingDescriptionLong') || checkMaxLength('marketingDescriptionLong')}">
            <label class="pt-1 pb-1">Marketing Description</label><label style="color:red;">*</label>
            <div class="document-editor">
              <app-prime-editor [formCName]="'marketingDescriptionLong'" [form]="marketingDetails"
                        [disabled]="isEditMarketingDetails? null : true"
              ></app-prime-editor>
            </div>
            <span class="warning-text" *ngIf="checkRequired('marketingDescriptionLong')">This is a required field, fill in before submitting request</span>
            <span class="warning-text" *ngIf="checkMaxLength('marketingDescriptionLong')">{{showMaxLengthErrorMessage('marketingDescriptionLong')}}</span>
          </div>
        </div>
        <br/>
      </div>
      <div class="row mb-3">
        <div class="col-lg-12">
          <div class="form-group" [ngClass]="{'warning' : checkMaxLength('searchTerms')}">
            <label class="pt-1 pb-1">Search Terms</label>
            <input class="form-control"
                   pInputText
                   [attr.disabled]="isEditMarketingDetails ? null : true"
                   formControlName="searchTerms"/>
            <span class="warning-text" *ngIf="checkMaxLength('searchTerms')">{{showMaxLengthErrorMessage('searchTerms')}}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
